import React from 'react';
import { projects } from '../data';
import './Projects.css';

export default function Projects() {
  return (
    <section id="projects" className="section" data-scene="baker">
      <div className="panel">
        <div className="section-head">
          <h2 className="section-head__title">Trail reports</h2>
          <p className="section-head__sub">Projects I’ve built outside of work.</p>
        </div>

        <div className="reports">
          {projects.map((p) => (
            <article className="report" key={p.title}>
              <header className="report__head">
                <h3 className="report__title">{p.title}</h3>
                <span className="report__date">{p.date}</span>
              </header>
              <p className="report__sub">{p.sub} · {p.role}</p>
              <p className="report__desc">{p.desc}</p>
              <div className="report__foot">
                <ul className="stack" aria-label="Built with">
                  {p.tags.map((t) => <li key={t}>{t}</li>)}
                </ul>
                {p.link && (
                  <a className="report__link" href={p.link} target="_blank" rel="noreferrer">
                    Source →
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
